<template>
  <div class="panel-header">
    <div class="panel-header__content">
      <img
        class="panel-header__logo"
        :src="require('assets/images/new-qp-logo.svg')"
        alt="Quero Pago"
      >

      <dropdown-menu :show-dropdown-icon="true" :position="'left'">
        <template slot="menu-trigger">
          <z-icon
            :icon="['far', 'user-circle']"
            size="large"
          />
        </template>
        <template slot="menu-content">
          <div class="panel__menu-item" @click="logout">
            <z-text tag="div" size="medium" color="interactive">
              <z-icon
                :icon="['far', 'sign-out']"
                class="panel__menu-icon"
              />
              Sair da conta
            </z-text>
          </div>
        </template>
      </dropdown-menu>
    </div>
  </div>
</template>

<script>
import SessionService from 'services/SessionService';
import DropdownMenu from 'components/dropdown-menu';

export default {
  components: {
    DropdownMenu,
  },
  methods: {
    logout() {
      this.$router.replace({ name: 'landing' });
      SessionService.clear();
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-header {
  background-color: var(--color-white);
  box-shadow: var(--box-shadow-high);
  padding: var(--space-medium);
}

.panel-header__content {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1140px;
}

.panel-header__logo {
  height: var(--size-jumbo);

  @media screen and (max-width: $screen-md-max) {
    height: var(--size-large);
  }
}

.panel__menu-item {
  cursor: pointer;
}

.panel__menu-icon {
  margin-right: var(--space-small);
}
</style>
